export default {
  ROOT_URL: process.env.REACT_APP_ROOT_URL || 'https://rails.chemdata.net'
}
